<template>
  <b-col class="mt-4 mt-xl-0 device-data panel panel--tabbed">
    <loader watch="guard1000FaultElectricalDataImpedance">
      <b-tabs>
        <b-tab :key="tabsNames[0]" :title="tabsNames[0]">
          <template v-if="faultElectricalDataImpedance.createdAt">
            <div class="visnet-events__fault-impedance justify-content-center pb-2">
              Best impedance:
            </div>
            <ShowAttribute
              v-for="(value, key) in changeDateFormatAndRepackage(
                faultElectricalDataImpedance.bestImpedance
              )"
              :key="`best${key}`"
              :value="value"
              :label="key"
            />
            <div class="visnet-events__fault-impedance justify-content-center pb-2">
              Latest impedance:
            </div>
            <ShowAttribute
              v-for="(value, key) in changeDateFormatAndRepackage(
                faultElectricalDataImpedance.latestImpedance
              )"
              :key="`latest${key}`"
              :value="value"
              :label="key"
            />
          </template>
          <template v-else>
            <b-row>No Impedance Data</b-row>
          </template>
        </b-tab>
      </b-tabs>
    </loader>
  </b-col>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import MomentTimezone from 'moment-timezone';
import ShowAttribute from '@/components/device/show-attribute';
import { FORMAT_YMD_TIMEZONE } from '@/components/shared/date-format';

const MAPPED_NAMES = {
  voltage: 'Busbar Voltage',
  currentRms: 'Current RMS',
  voltageRms: 'Cable Voltage'
};
const TABS_NAMES = ['Impedance'];

export default {
  name: 'Guard1000FaultDataTable',
  components: { ShowAttribute },
  data() {
    return {
      tabIndex: 0,
      mappedNames: MAPPED_NAMES,
      tabsNames: TABS_NAMES
    };
  },
  computed: {
    ...mapState({
      faultElectricalDataImpedance: state => state.guard1000FaultElectricalDataImpedance.data
    })
  },
  mounted() {
    const { externalGuardId, projectCode, substationCode, feederNumber } = this.$route.params;

    const electricalDataPayload = {
      externalGuardId,
      projectCode,
      substationCode,
      feederNumber
    };

    this.fetchImpedanceData(electricalDataPayload);
  },
  methods: {
    ...mapActions({
      fetchImpedanceData: 'guard1000FaultElectricalDataImpedance/fetchFaultElectricalDataImpedance'
    }),
    changeDateFormatAndRepackage(object) {
      const { date, ...rest } = object;

      const dateFormatted = date ? MomentTimezone(date * 1000).format(FORMAT_YMD_TIMEZONE) : '-';

      return { date: dateFormatted, ...rest };
    }
  }
};
</script>
